const module = {
  config: {
    name: "distribusi-bibit",
    svg: "../static/img/icon/menu/truck.svg",
    desc: "Berisi modul distribusi bibit",
    layout: true
  },
  routes: [
    // period
    {
      name: "Periode Distribusi",
      icon: "ri-calendar-todo-line",
      path: "/distribution-period",
      component: () => import("./period.vue"),
      separator: "Periode"
    },
    // request
    {
      name: "Sosialisasi Tanam",
      icon: "ri-calendar-check-line",
      path: "/calendar-sosialisasi-tanam",
      component: () => import("./sostam/main.vue"),
      separator: "Kalendar GEKO"
    },
    // confirm-ph
    {
      name: "Penilikan Lubang",
      icon: "ri-checkbox-circle-line",
      path: "/distribution-confirm-ph",
      component: () => import("./penlub/main.vue"),
      separator: "Kalendar GEKO"
    },
    // monitoring
    {
      name: "Monitoring Distribusi",
      icon: "ri-share-forward-box-line",
      path: "/distribution-monitoring",
      component: () => import("./monitoring-distribution/index.vue"),
      separator: "Monitoring"
    },
    // allocation-ff
    {
      name: "1. Alokasi Bibit Distribusi",
      icon: "ri-share-forward-box-line",
      path: "/distribution-allocation-ff",
      component: () => import("./allocation-ff.vue"),
      separator: "Reguler"
    },
    // allocation-transportation
    {
      name: "2. Alokasi Kendaraan",
      icon: "ri-car-washing-line",
      path: "/distribution-allocation-transportation",
      component: () => import("./allocation-transportation.vue"),
      separator: "Reguler"
    },
    // 3. Print Label
    {
      name: "3. Print Label",
      icon: "ri-barricade-fill",
      path: "/distribution-loading-line",
      component: () => import("./loading-line.vue"),
      separator: "Reguler"
    },
    // 4. Loading & Distribusi
    {
      name: "4. Loading & Distribusi",
      icon: "ri-caravan-line",
      path: "/distribution-loading-and-distribute",
      component: () => import("./loading-bag/loading-bag.vue"),
      separator: "Reguler"
    },
    // 5. Report Penerimaan
    {
      name: "5. Report Penerimaan",
      icon: "ri-file-text-line",
      path: "/distribution-received-report",
      component: () => import("./report-received-distribution.vue"),
      separator: "Reguler"
    },
    // 6. Statistik Distribusi
    {
      name: "6. Statistik Distribusi",
      icon: "ri-bar-chart-horizontal-fill",
      path: "/distribution-report",
      component: () => import("./report-distribution.vue"),
      separator: "Reguler"
    },
    // 1. Permintaan Addendum
    {
      name: "1. Permintaan Addendum",
      icon: "ri-chat-new-line",
      path: "/addendum-distribution",
      component: () => import("./addendum/request.vue"),
      separator: "Addendum Distribusi Regular"
    },
    // 2. Inisiasi Pengembalian Bibit
    {
      name: "2. Inisiasi Pengembalian Bibit",
      icon: "ri-order-play-line",
      path: "/addendum-distribution-return",
      component: () => import("./addendum/return.vue"),
      separator: "Addendum Distribusi Regular"
    },
    // 3. Pengiriman Ulang Bibit
    {
      name: "3. Pengiriman Ulang Bibit",
      icon: "ri-align-top",
      path: "/addendum-distribution-resend",
      component: () => import("./addendum/resend.vue"),
      separator: "Addendum Distribusi Regular"
    },
    // internal-and-custom-project-request
    // 1. Permintaan
    {
      name: "1. Permintaan",
      icon: "ri-chat-new-line",
      path: "/internal-and-custom-project-request",
      component: () => import("./internal-and-custom-project/request.vue"),
      separator: "Custom"
    },
    // 2. Alokasi Bibit & Kendaraan
    {
      name: "2. Alokasi Bibit & Kendaraan",
      icon: "ri-share-forward-box-line",
      path: "/internal-and-custom-project-allocation",
      component: () => import("./internal-and-custom-project/allocation.vue"),
      separator: "Custom"
    },
    // 3. Loading & Distribusi
    {
      name: "3. Loading & Distribusi",
      icon: "ri-caravan-line",
      path: "/internal-and-custom-project-loading-and-distribution",
      component: () => import("./internal-and-custom-project/loading-and-distribution.vue"),
      separator: "Custom"
    },
    // 4. Inisiasi Distribusi Internal
    {
      name: "4. Inisiasi Distribusi Internal",
      icon: "ri-order-play-line",
      path: "/internal-and-custom-project-inisiasi",
      component: () => import("./internal-and-custom-project/inisiasi.vue"),
      separator: "Custom"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/distribution/_index.js